import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import React, { useState, useEffect } from 'react';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.less';
import { FormLabel } from '@mui/material';

import Campaign from 'entities/campaign/model';

const { Option, OptGroup } = Select;

const FormSelectBoxEntitySelector = ({
  placeholder,
  input,
  meta,
  fetchOptions,
  options: syncOptions,
  optionGroups,
  multiple,
  showSearch,
  allowClear,
  style,
}) => {
  const { value } = input;
  const [asyncOptions, setOptions] = useState(fromJS([]));
  useEffect(() => {
    let mounted = true;
    if (fetchOptions) {
      fetchOptions(undefined, value).subscribe(
        (o) => mounted && setOptions(fromJS(o)),
        () => {}
      );
    }
    return () => {
      mounted = false;
    };
  }, [fetchOptions, value]);

  const options = syncOptions || asyncOptions;
  return (
    <>
      <Select
        showSearch={showSearch}
        allowClear={allowClear}
        value={value && value.toArray ? value.toArray() : value || undefined}
        placeholder={placeholder}
        mode={multiple ? 'multiple' : 'default'}
        onChange={(selectedOptions) => input.onChange(selectedOptions || null)}
        filterOption={(selectInput, option) =>
          typeof option?.props?.children === 'string' &&
          option.props.children.toLowerCase().indexOf(selectInput.toLowerCase()) >= 0
        }
        style={{
          width: 300,
          ...style,
        }}
      >
        {optionGroups?.length > 0
          ? optionGroups.map((optionGroup) => (
              <OptGroup key={optionGroup.label} label={optionGroup.label}>
                {optionGroup.options.map((option) => (
                  <Option
                    key={option?.get?.('id') || option?.get?.('code') || option}
                    value={option?.get?.('id') || option?.get?.('code') || option}
                  >
                    {option?.get?.('name') || option}
                  </Option>
                ))}
              </OptGroup>
            ))
          : options
              .map((option) => (
                <Option
                  key={option?.get?.('id') || option?.get?.('code') || option}
                  value={option?.get?.('id') || option?.get?.('code') || option}
                >
                  {option instanceof Campaign ? option.title : option?.get?.('name') || option}
                </Option>
              ))
              .toArray()}
      </Select>
      {(meta?.dirty || meta?.touched) && meta?.error && (
        <div>
          <FormLabel error style={{ fontSize: 12, marginTop: 10, marginLeft: 10 }}>
            {meta.error}
          </FormLabel>
        </div>
      )}
    </>
  );
};
FormSelectBoxEntitySelector.propTypes = {
  options: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  optionGroups: PropTypes.array,
  fetchOptions: PropTypes.func,
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  multiple: PropTypes.bool,
  showSearch: PropTypes.bool,
  allowClear: PropTypes.bool,
  style: PropTypes.object,
  meta: PropTypes.object,
};
export default FormSelectBoxEntitySelector;
